// extracted by mini-css-extract-plugin
module.exports = {"down":"collapse_down__3Za_2","icon":"collapse_icon__4-TxN","header":"collapse_header__1eX4w","content":"collapse_content__3K7L1","active":"collapse_active__3moir"};